/*
 * @Name: 环境配置
 */
var envTarget = process.env.VUE_APP_BUILD_ENV || 'dev'
var envConfig = require('./env.' + envTarget)

module.exports = envConfig
